// pages/UserSelectionPage.jsx
import React, { useState, useEffect } from 'react';
import {
  Container,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Box,
  Avatar
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import useUserStore from '../store/UserStore.js';
import { Person as PersonIcon } from '@mui/icons-material';
import { Header } from '../components/Header.jsx';
import { UsuariListButton } from '../components/UsuariListButton.jsx';
import { getUsers } from '../services/getUsers.js';
import { useTranslation } from 'react-i18next';
import { getProfileImage } from '../services/getProfileImage.js';
import { getIdPersonaToken } from '../services/generateTokenIdPersona.js';
import { userData } from '../services/userData.js';

export const UserSelectionPage = ({ setIsAuthenticated }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const user = useUserStore(state => state.user);
  const setUser = useUserStore(state => state.setUser);
  const [usersList, setUsersList] = useState([]);
  const [usersImages, setUsersImages] = useState({});

  useEffect(() => {
    const fetchUsersAndImages = async () => {
      try {
        const response = await getUsers(user.email);
        const users = response.data;
        setUsersList(users);

        users.forEach(async (userItem) => {
          try {
            const imageResponse = await getProfileImage(userItem.idpersona);
            const imageBlob = imageResponse.data;
            const imageUrl = URL.createObjectURL(imageBlob);

            setUsersImages(prevState => ({
              ...prevState,
              [userItem.idpersona]: imageUrl,
            }));
          } catch (error) {
            console.error(`Error al obtener la imagen de perfil para el usuario ${userItem.idpersona}:`, error);
          }
        });
      } catch (error) {
        console.error('Error al obtener los usuarios:', error);
      }
    };

    fetchUsersAndImages();

    return () => {
      Object.values(usersImages).forEach(url => URL.revokeObjectURL(url));
    };
  }, [user.email]);

  const handleUserSelect = async (userItem) => {
    try {
      setUser({
        idpersona: userItem.idpersona,
        email: userItem.email,
      });

      const imageResponse = await getProfileImage(userItem.idpersona);
      const imageBlob = imageResponse.data;
      const reader = new FileReader();
      reader.readAsDataURL(imageBlob);
      reader.onloadend = () => {
        localStorage.setItem('userImage', reader.result);
      };

      localStorage.setItem('IdPersona_selected', true);

      const tokenResponse = await getIdPersonaToken(userItem.idpersona);
      if (tokenResponse.data.message === 'Token obtenido') {

        const response = await userData();
        const apiData = response.data;
        localStorage.setItem('userData_nom', apiData.nombre)
        localStorage.setItem('userData_cognoms', apiData.apellidos)

        navigate('/home');
      }
    } catch (error) {
      console.error('Error al seleccionar el usuario:', error);
    }
  };


  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
      width: '100%',
    }}>
      <Header setIsAuthenticated={setIsAuthenticated} />
      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        flex: 1,
      }}>
        <Container sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: 4,
        }}>
          <Typography variant="h4" sx={{ mb: 6, color: 'black', textAlign: 'center' }}>
            {t('userSelection.selectUser')} <span style={{ color: '#4caf50' }}>{t('userSelection.user')}</span>
          </Typography>
          <List sx={{ width: '100%', maxWidth: 540 }}>
            {usersList.map((userItem) => (
              <ListItem key={userItem.idpersona} disablePadding>
                <UsuariListButton
                  onClick={() => handleUserSelect(userItem)}
                >
                  <ListItemIcon>
                    {usersImages[userItem.idpersona] || localStorage.getItem('userImage') ? (
                      <Avatar
                        src={usersImages[userItem.idpersona]}
                        alt={`${userItem.persona.nombre} ${userItem.persona.apellidos}`}
                      />
                    ) : (
                      <Avatar>
                        <PersonIcon />
                      </Avatar>
                    )}
                  </ListItemIcon>
                  <ListItemText primary={`${userItem.persona.nombre} ${userItem.persona.apellidos}`} />
                </UsuariListButton>
              </ListItem>
            ))}
          </List>
        </Container>
      </Box>
    </Box>
  );
};
